export const NOTIFICATIONS_SERVICES = [
  'anomaly_notification',
  'image_download',
  'drone_upload',
  'weekly_field_insights',
  'system_notification',
  'ndvi_threshold_checker',
] as const;
export const NOTIFICATIONS_TRIGGERS = [
  'single_property',
  'single_organization',
  'multiple_properties_and_organizations',
  'fields_enrolled',
  'drone_download',
  'drone_image_upload',
  'image_catalog_file',
  'single_org',
  'weekly_field_insights',
  // ndvi_threshold_checker: one trigger per card layout.
  'single_field',
  'single_farm',
  'multiple_farms',
] as const;

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace NotificationCenter {
  export type NotificationService = typeof NOTIFICATIONS_SERVICES[number];
  export type NotificationTrigger = typeof NOTIFICATIONS_TRIGGERS[number];
  export type NotificationStatus = 'READ' | 'UNREAD';

  export interface Notification {
    id: string;
    service: NotificationService;
    trigger: NotificationTrigger;
    status: NotificationStatus;
    date: number;
  }
}
